import DataLoader from '../data-loader';
import getSaleableProductIds from '../../utils/get-saleable-product-ids';
import makeSelectHasAllRequiredProductsLoaded from '../../selectors/make-select-has-all-required-products-loaded';
import selectProductsError from '../../selectors/select-products-error';

export default DataLoader({
  selectIsDataLoaded: makeSelectHasAllRequiredProductsLoaded(getSaleableProductIds()),
  selectLoadingError: selectProductsError,
});
